import { render, staticRenderFns } from "./XSelect.vue?vue&type=template&id=d143c0f6&"
import script from "./XSelect.vue?vue&type=script&lang=js&"
export * from "./XSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports